// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import { Fragment, type ReactNode } from 'react';

interface Tab {
  key: string;
  label: string;
  count?: number;
}

type TabBarProps = Readonly<{
  tabs: Tab[];
  activeTab: string;
  onTabChange: (key: string) => void;
  className?: string;
  renderBefore?: { key: string; node: ReactNode };
}>;

export function TabBar({ tabs, activeTab, onTabChange, className = '', renderBefore }: TabBarProps) {
  return (
    <div className={`flex w-full gap-8 ${className}`}>
      {tabs.map((tab) => (
        <Fragment key={tab.key}>
          {renderBefore?.key === tab.key && (
            <div className="flex items-center">{renderBefore.node}</div>
          )}
          <button
            className={`group relative flex items-center gap-2 bg-none border-none px-md py-sm font-sans text-body-02 font-normal leading-normal cursor-pointer transition-colors
              ${activeTab === tab.key ? "text-purple-primary after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:bg-purple-primary" : 'text-grey-04 hover:text-purple-primary'}`}
            onClick={() => onTabChange(tab.key)}
          >
            {tab.label}
            {tab.count !== undefined && (
              <span className={`flex w-[16px] h-[16px] p-[6.667px] flex-col justify-center items-center rounded-full text-white font-sans text-[8px] font-normal leading-normal transition-colors
                ${activeTab === tab.key ? 'bg-purple-primary' : 'bg-grey-04 group-hover:bg-purple-primary'}`}>{tab.count}</span>
            )}
          </button>
        </Fragment>
      ))}
    </div>
  );
}
